/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OauthSignInRouteImport } from './routes/oauth-sign-in'
import { Route as OauthConsentRouteImport } from './routes/oauth-consent'
import { Route as HostsRouteImport } from './routes/hosts'
import { Route as DeleteAccountRouteImport } from './routes/delete-account'
import { Route as ChatsRouteImport } from './routes/chats'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HostsIndexRouteImport } from './routes/hosts.index'
import { Route as ChatsIndexRouteImport } from './routes/chats.index'
import { Route as ChatsChatIdRouteImport } from './routes/chats.$chatId'

const OauthSignInRoute = OauthSignInRouteImport.update({
  id: '/oauth-sign-in',
  path: '/oauth-sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: '/oauth-consent',
  path: '/oauth-consent',
  getParentRoute: () => rootRouteImport,
} as any)
const HostsRoute = HostsRouteImport.update({
  id: '/hosts',
  path: '/hosts',
  getParentRoute: () => rootRouteImport,
} as any)
const DeleteAccountRoute = DeleteAccountRouteImport.update({
  id: '/delete-account',
  path: '/delete-account',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatsRoute = ChatsRouteImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const HostsIndexRoute = HostsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HostsRoute,
} as any)
const ChatsIndexRoute = ChatsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatsRoute,
} as any)
const ChatsChatIdRoute = ChatsChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => ChatsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/chats': typeof ChatsRouteWithChildren
  '/delete-account': typeof DeleteAccountRoute
  '/hosts': typeof HostsRouteWithChildren
  '/oauth-consent': typeof OauthConsentRoute
  '/oauth-sign-in': typeof OauthSignInRoute
  '/chats/$chatId': typeof ChatsChatIdRoute
  '/chats/': typeof ChatsIndexRoute
  '/hosts/': typeof HostsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/delete-account': typeof DeleteAccountRoute
  '/oauth-consent': typeof OauthConsentRoute
  '/oauth-sign-in': typeof OauthSignInRoute
  '/chats/$chatId': typeof ChatsChatIdRoute
  '/chats': typeof ChatsIndexRoute
  '/hosts': typeof HostsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/chats': typeof ChatsRouteWithChildren
  '/delete-account': typeof DeleteAccountRoute
  '/hosts': typeof HostsRouteWithChildren
  '/oauth-consent': typeof OauthConsentRoute
  '/oauth-sign-in': typeof OauthSignInRoute
  '/chats/$chatId': typeof ChatsChatIdRoute
  '/chats/': typeof ChatsIndexRoute
  '/hosts/': typeof HostsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/chats'
    | '/delete-account'
    | '/hosts'
    | '/oauth-consent'
    | '/oauth-sign-in'
    | '/chats/$chatId'
    | '/chats/'
    | '/hosts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/delete-account'
    | '/oauth-consent'
    | '/oauth-sign-in'
    | '/chats/$chatId'
    | '/chats'
    | '/hosts'
  id:
    | '__root__'
    | '/'
    | '/account'
    | '/chats'
    | '/delete-account'
    | '/hosts'
    | '/oauth-consent'
    | '/oauth-sign-in'
    | '/chats/$chatId'
    | '/chats/'
    | '/hosts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AccountRoute: typeof AccountRoute
  ChatsRoute: typeof ChatsRouteWithChildren
  DeleteAccountRoute: typeof DeleteAccountRoute
  HostsRoute: typeof HostsRouteWithChildren
  OauthConsentRoute: typeof OauthConsentRoute
  OauthSignInRoute: typeof OauthSignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/oauth-sign-in': {
      id: '/oauth-sign-in'
      path: '/oauth-sign-in'
      fullPath: '/oauth-sign-in'
      preLoaderRoute: typeof OauthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth-consent': {
      id: '/oauth-consent'
      path: '/oauth-consent'
      fullPath: '/oauth-consent'
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hosts': {
      id: '/hosts'
      path: '/hosts'
      fullPath: '/hosts'
      preLoaderRoute: typeof HostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/delete-account': {
      id: '/delete-account'
      path: '/delete-account'
      fullPath: '/delete-account'
      preLoaderRoute: typeof DeleteAccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chats': {
      id: '/chats'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof ChatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hosts/': {
      id: '/hosts/'
      path: '/'
      fullPath: '/hosts/'
      preLoaderRoute: typeof HostsIndexRouteImport
      parentRoute: typeof HostsRoute
    }
    '/chats/': {
      id: '/chats/'
      path: '/'
      fullPath: '/chats/'
      preLoaderRoute: typeof ChatsIndexRouteImport
      parentRoute: typeof ChatsRoute
    }
    '/chats/$chatId': {
      id: '/chats/$chatId'
      path: '/$chatId'
      fullPath: '/chats/$chatId'
      preLoaderRoute: typeof ChatsChatIdRouteImport
      parentRoute: typeof ChatsRoute
    }
  }
}

interface ChatsRouteChildren {
  ChatsChatIdRoute: typeof ChatsChatIdRoute
  ChatsIndexRoute: typeof ChatsIndexRoute
}

const ChatsRouteChildren: ChatsRouteChildren = {
  ChatsChatIdRoute: ChatsChatIdRoute,
  ChatsIndexRoute: ChatsIndexRoute,
}

const ChatsRouteWithChildren = ChatsRoute._addFileChildren(ChatsRouteChildren)

interface HostsRouteChildren {
  HostsIndexRoute: typeof HostsIndexRoute
}

const HostsRouteChildren: HostsRouteChildren = {
  HostsIndexRoute: HostsIndexRoute,
}

const HostsRouteWithChildren = HostsRoute._addFileChildren(HostsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountRoute: AccountRoute,
  ChatsRoute: ChatsRouteWithChildren,
  DeleteAccountRoute: DeleteAccountRoute,
  HostsRoute: HostsRouteWithChildren,
  OauthConsentRoute: OauthConsentRoute,
  OauthSignInRoute: OauthSignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
